import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FlashCardInterface} from 'fuse-core/components/flashcard/flash-card.interface';

@Component({
    selector: 'app-dictionary-card',
    templateUrl: './dictionary-card.component.html',
})
export class DictionaryCardComponent {
    @Output() state = new EventEmitter<string>();
    @Output() openCard = new EventEmitter<boolean>();
    @Input() flashCard!: FlashCardInterface;
    @Input() idCardPlaying = '';

    constructor() {
    }

    public cardClick() {
        this.state.emit('card-click');
    }

    public isPlaying(): boolean {
        return this.idCardPlaying && this.idCardPlaying !== '' && this.idCardPlaying === this.flashCard.id;
    }

    public openCardActivity(): void{
        this.openCard.emit(true);
    }

}


